var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77328 5.90838C11.0399 3.63613 11.6732 2.5 12.6201 2.5C13.567 2.5 14.2003 3.63612 15.4669 5.90837L15.7946 6.49623C16.1546 7.14193 16.3345 7.46479 16.6152 7.67781C16.8958 7.89083 17.2452 7.9699 17.9442 8.12805L18.5806 8.27203C21.0402 8.82856 22.2701 9.10682 22.5627 10.0477C22.8553 10.9886 22.0169 11.9691 20.34 13.9299L19.9062 14.4372C19.4297 14.9944 19.1914 15.273 19.0842 15.6177C18.9771 15.9624 19.0131 16.3341 19.0851 17.0776L19.1507 17.7544C19.4042 20.3706 19.531 21.6787 18.765 22.2602C17.9989 22.8417 16.8474 22.3115 14.5444 21.2512L13.9486 20.9768C13.2942 20.6755 12.967 20.5248 12.6201 20.5248C12.2732 20.5248 11.946 20.6755 11.2916 20.9768L10.6958 21.2512C8.3928 22.3115 7.2413 22.8417 6.47527 22.2602C5.70924 21.6787 5.836 20.3706 6.08952 17.7544L6.1551 17.0776C6.22715 16.3341 6.26317 15.9624 6.15598 15.6177C6.0488 15.273 5.81055 14.9944 5.33404 14.4372L4.90022 13.9299C3.22337 11.9691 2.38494 10.9886 2.67754 10.0477C2.97014 9.10682 4.19998 8.82856 6.65966 8.27203L7.29601 8.12805C7.99497 7.9699 8.34445 7.89083 8.62506 7.67781C8.90567 7.46479 9.08565 7.14194 9.44559 6.49623L9.77328 5.90838Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarSolar);
export default __webpack_public_path__ + "static/media/icon-star-solar.4fbc7a5945b82701225c644f2e39b333.svg";
export { ForwardRef as ReactComponent };